import { render, staticRenderFns } from "./ServicesAddDialog.vue?vue&type=template&id=130cf344&scoped=true"
import script from "./ServicesAddDialog.vue?vue&type=script&lang=js"
export * from "./ServicesAddDialog.vue?vue&type=script&lang=js"
import style0 from "./ServicesAddDialog.vue?vue&type=style&index=0&id=130cf344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130cf344",
  null
  
)

export default component.exports